// extracted by mini-css-extract-plugin
module.exports = {"evaluationIcon":"PeriodicalEvaluation_evaluationIcon__3kX97"};